export interface SERVICE_TYPE_OPTIONS {
  value: string;
  label: string;
}

export const SERVICE_TYPE_OPTIONS: SERVICE_TYPE_OPTIONS[] = [
  { value: 'trademark', label: '商标服务' },
  { value: 'patent', label: '专利服务' },
  { value: 'copyright', label: '版权服务' },
  { value: 'company', label: '工商服务' },
  { value: 'barcode', label: '条形码服务' },
  { value: 'other', label: '其他服务' },
];

export default SERVICE_TYPE_OPTIONS;
